import {
    Paper,
    Typography,
    Grid, CardHeader, Card, CardActions, CardContent
} from '@mui/material'
import { Box } from '@mui/system';
import LogoutButton  from "../Controls/LogoutButton";
import {useAuth0} from "@auth0/auth0-react";
import LoginButton from "../Controls/LoginButton";
import {DeviceTypeSelector} from "../Controls/DeviceTypeSelector";
import * as React from "react";

export function Header() {
    const { isAuthenticated} = useAuth0();
  return (
      <div>
    <Paper
      elevation={4}
    >
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <Box p={1}>
          <img alt="spotai" src="/logo.svg" height="37"></img>
          </Box>
        </Grid>
        <Grid item xs={2}></Grid>
        <Grid item xs={6}>
          <Typography p={1} variant="h4">Manufacturing Console</Typography>
        </Grid>
        <Grid item xs={2} marginTop={1}>
            {isAuthenticated ? <LogoutButton></LogoutButton> : <></>}
        </Grid>
      </Grid>
    </Paper>
        { isAuthenticated ? <></> :
            <div>
            <Grid container spacing={2} p={3}>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}>
                    <Card>
                        <Box textAlign={"center"}>
                            <Typography p={5} variant={"h5"}>
                                Identity Server Login
                            </Typography>
                            <LoginButton></LoginButton>
                        </Box>
                    </Card>
                </Grid>
                <Grid item xs={4}></Grid>
            </Grid>
            </div>
            }
    </div>
  )
}